<template>
  <div class="burger-wrapper">
    <a id="burgerSwitcher"
       :class="{'is-active': isBurgerActive}" role="button" class="navbar-burger"
       data-target="navMenu" aria-label="menu"
       aria-expanded="false" @click="toggleBurgerMenu">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
    <div id="navMenu" :class="{'is-active': isBurgerActive}" class="navbar-menu">
      <a v-for="link of links" :key="link.name" class="navbar-item" @click="onItemClick(link, $event)">{{ link.name }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    links: Array
  },
  data: function() {
    return {isBurgerActive: false};
  },
  methods: {
    toggleBurgerMenu() {
      this.isBurgerActive = !this.isBurgerActive;
      this.$mam.trackNavMenuClicked();
    },
    onItemClick(link, event) {
      link.click(event);
      this.isBurgerActive = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.burger-wrapper {
  padding: 0 17px;
}

#navMenu {
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  background-color: var(--white);
}

.navbar-menu .navbar-item:hover {
  color: var(--secondary);
}

.navbar-burger > span {
  background-color: var(--primary);
}

.navbar-burger:hover > span {
  background-color: var(--secondary);
}
</style>
